import React from "react";
import { Box } from "@mui/material";

// Components
import CostsSummaryCards from "./CostsSummaryCards";
import CostsCharts from "./charts/CostsCharts";

/**
 * Dashboard component displaying summary cards and charts
 * @returns {JSX.Element} Dashboard component
 */
const CostsDashboard = ({
  totalCosts,
  categories,
  suppliers,
  averageCost,
  loading,
  categorySummary,
  weeklySummary,
  chartType,
  activeTab,
  chartColors,
  renderCustomizedPieLabel,
  handleTabChange,
  handleChartTypeChange,
  getCategoryChartData,
  getWeeklyChartData,
}) => {
  return (
    <Box sx={{ p: 6 }}>
      {/* Summary Cards */}
      <CostsSummaryCards
        totalCosts={totalCosts}
        categoriesCount={categories.length}
        suppliersCount={suppliers.length}
        averageCost={averageCost}
        loading={loading}
      />

      {/* Charts Section */}
      <CostsCharts
        categorySummary={categorySummary}
        weeklySummary={weeklySummary}
        chartType={chartType}
        activeTab={activeTab}
        chartColors={chartColors}
        renderCustomizedPieLabel={renderCustomizedPieLabel}
        handleTabChange={handleTabChange}
        handleChartTypeChange={handleChartTypeChange}
        getCategoryChartData={getCategoryChartData}
        getWeeklyChartData={getWeeklyChartData}
        loading={loading}
      />
    </Box>
  );
};

export default CostsDashboard;
